import { SettingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Typography,
} from "antd";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import tabList from "./tabs/tabList.json";
// import appStatic from "../../../../../../config/appStatic";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";
import {
  AccountFacility,
  AmountFormat,
  handleCallDepositAccActionButtons,
  isDebit,
} from "../../../../components/facilities/AccountFacility";
import Charges from "./tabs/Charges";
import InterestRateChart from "./tabs/InterestRateChart";
import Transactions from "./tabs/Transactions";
import Certificate from "./tabs/Certificate";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const DetailCallDepositAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  //   const { monthList } = appStatic;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [interestRateChartList, setInterestRateChartList] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("interestRateChart");
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(25);
  const [totalItems, setTotalItems] = useState(0);
  const [menuProps, setMenuProps] = useState({
    items: [],
  });

  useEffect(() => {
    console.log(state);

    {
      BOM.HasPermission("READ_FIXEDDEPOSITACCOUNT") && getDetailById();
    }
  }, []);

  const getDetailById = (offset = 0, _limit = Number(tableCount)) => {
    setIsLoading(true);

    const url = `${apiConfig.FixedDepositAccounts}/${state.id}?associations=all`;

    let body = {
      session,
      offset: offset,
      limit: _limit,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);

        let tempInterestRateChartArray = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChartArray.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType ? element?.periodType?.value : "-",
            periodFromTo: `${
              element?.fromPeriod ? element?.fromPeriod : "-"
            } - ${element?.toPeriod ? element?.toPeriod : "-"}`,
            amountRange: `${
              element?.amountRangeFrom
                ? element?.amountRangeFrom?.toLocaleString()
                : "-"
            } - ${element?.amountRangeTo ? element?.amountRangeTo?.toLocaleString() : "-"}`,
            interest: element?.annualInterestRate
              ? element?.annualInterestRate
              : "-",
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            paymentDueAt: element?.chargeTimeType
              ? element?.chargeTimeType?.value
              : "-",
            calculationType: element?.chargeCalculationType
              ? element?.chargeCalculationType?.value
              : "-",
            due: `${element?.currency ? element?.currency?.code : "-"}${
              element?.amount ? element?.amount : "-"
            }`,
            paid: `${element?.currency ? element?.currency?.code : "-"}${
              element?.amountPaid
                ? element?.amountPaid
                : element?.amountPaid === 0
                  ? "0"
                  : "-"
            }`,
            waive: `${element?.currency ? element?.currency?.code : "-"}${
              element?.amountWaived
                ? element?.amountWaived
                : element?.amountWaived === 0
                  ? "0"
                  : "-"
            }`,
            outstanding: `${element?.currency ? element?.currency?.code : "-"}${
              element?.amountOutstanding
                ? element?.amountOutstanding
                : element?.amountOutstanding === 0
                  ? "0"
                  : "-"
            }`,
          });
        });

        objDetail?.transactions?.forEach((element, i) => {
          if (i < 2000) {
            // TODO: Remove this hardcoded value
            tempTransactionsArray.push({
              key: element?.id,
              id: element?.id,
              transactionDate: element?.date
                ? BOM.DateTime(element?.date, "only-date")
                : "-",
              transactionType: element?.transactionType
                ? element?.transactionType?.value
                : "-",
              debit: isDebit(element?.transactionType)
                ? Number(element?.amount).toLocaleString()
                : "-",
              credit: !isDebit(element?.transactionType)
                ? Number(element?.amount).toLocaleString()
                : "-",
              balance: element?.runningBalance
                ? `${element?.currency?.code} ${Number(element?.runningBalance).toLocaleString()}`
                : "-",
            });
          }
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);
        setInterestRateChartList(tempInterestRateChartArray);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleCallDepositAccActionButtons(objDetail),
          onClick: (e) => {
            const item = handleCallDepositAccActionButtons(objDetail).find(
              (element) => element.key === e.key,
            );

            if (item) {
              switch (item?.label.toLowerCase()) {
                case "calculate interest":
                  return calculateInterest();
                case "post interest":
                  return postInterest();
                case "disable withhold tax":
                  return disableWithholdTax();
                case "enable withhold tax":
                  return enableWithholdTax();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                    },
                  });
              }
            }
          },
        });

        /**
         * STOP LOADER
         */

        setIsLoading(false);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getDetailById(offset, limit);
    setCurrentPage(1);
  };

  function postInterest() {
    setIsLoading(true);
    const params = {
      command: "postInterest",
    };
    const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            " Call Deposit Account Interest was succesfully posted",
          );
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      },
    );
  }

  function calculateInterest() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            " Call Deposit Account was succesfully calculated",
          );
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      },
    );
  }

  function disableWithholdTax() {
    setIsLoading(true);
    const params = {
      command: "updateWithHoldTax",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      withHoldTax: false,
      session,
      method: "PUT",
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            " Call Deposit Account was succesfully disabled",
          );
          getDetailById();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      },
    );
  }

  function enableWithholdTax() {
    setIsLoading(true);
    const params = {
      command: "updateWithHoldTax",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      withHoldTax: true,
      session,
      method: "PUT",
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            " Call Deposit Account was succesfully enabled",
          );
          getDetailById();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      },
    );
  }

  const onTabChange = (key) => {
    // console.log(key);
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    interestRateChart: (
      <InterestRateChart interestRateChartList={interestRateChartList} />
    ),
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        tableCount={tableCount}
        setTableCount={setTableCount}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        onRefresh={onRefresh}
      />
    ),
    charges: <Charges chargesList={chargesList} />,
    certificate: (
      <Certificate
        state={state}
        userData={userData}
        chargesList={chargesList}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailCallDepositAccount}
        pageItems={staticConfig.detailCallDepositAccountBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />

            <Row style={{ marginBottom: 30, padding: 10 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.clientName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.accountBalance}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={`Available Balance`}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.accountBalance}
                    // amount={accountDetails?.status === "Active" ? accountDetails?.summary?.accountBalance : accountDetails?.summary?.totalOverdue}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <CasaDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <InterestDetails accountDetails={accountDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailCallDepositAccount);

function CasaDetails(props) {
  const { accountDetails } = props;

  function displayMaturInstr() {
    if (accountDetails?.onAccountClosure) {
      if (
        accountDetails?.onAccountClosure.value.toLowerCase() ===
        "transfer to savings"
      ) {
        return `${accountDetails?.onAccountClosure.value} (to) ${accountDetails?.transferToSavingsAccount?.accountNo}`;
      } else {
        return accountDetails?.onAccountClosure.value;
      }
    } else {
      return " - ";
    }
  }
  function StatusMessage({ status }) {
    return (
      <div>
        {accountDetails?.onAccountClosure
          ? accountDetails?.onAccountClosure.value.toLowerCase() ===
            "transfer to savings"
            ? `${accountDetails?.onAccountClosure.value} (to) ${accountDetails?.transferToSavingsAccount?.accountNo}`
            : " - "
          : " - "}
      </div>
    );
  }

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.depositDetails}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.accountOfficer}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.fieldOfficerName
                  ? accountDetails?.fieldOfficerName
                  : "Unassigned"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.externalID}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId
                  ? accountDetails?.externalId
                  : "Not Provided"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.timeline?.activatedOnDate
                  ? BOM.FormatArrayDate(accountDetails.timeline.activatedOnDate)
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.maturityDate
                  ? `${BOM.FormatArrayDate(accountDetails.maturityDate)} (${BOM.GetDayOfWeek(
                      BOM.FormatArrayDate(accountDetails.maturityDate),
                    )})`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityInstruction}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.onAccountClosure
                  ? accountDetails?.onAccountClosure?.value?.toLowerCase() ===
                    "transfer to savings"
                    ? `${accountDetails?.onAccountClosure?.value} (to) ${accountDetails?.transferToSavingsAccount?.accountNo}`
                    : accountDetails?.onAccountClosure?.value
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.period}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.depositPeriod}{" "}
                {accountDetails?.depositPeriodFrequency?.value}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.withholdTaxAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.status?.prematureClosed
                  ? accountDetails?.summary?.totalWithholdTax
                      ?.toFixed(2)
                      .toLocaleString()
                  : accountDetails?.calculatedWithHoldTax
                    ? accountDetails?.calculatedWithHoldTax
                        ?.toFixed(2)
                        .toLocaleString()
                    : "-"}
              </Text>
            </Col>
          </Row>
        </div>

        {accountDetails?.withHoldTax && (
          <>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>{labelConfig.withholdTaxGroup}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.taxGroup
                      ? accountDetails?.taxGroup?.name
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
          </>
        )}
        {/* <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.depositIban}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>{accountDetails?.depositNumber}</Text>
            </Col>
          </Row>
        </div> */}
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;
  const maturityInterest =
    accountDetails?.maturityAmount - accountDetails?.depositAmount || 0;
  const withHoldTax = accountDetails?.withHoldTax;
  const netInterest = withHoldTax
    ? Number(maturityInterest) - Number(accountDetails?.calculatedWithHoldTax)
    : Number(maturityInterest);
  const maturityAmount = withHoldTax
    ? Number(accountDetails?.depositAmount) + Number(netInterest)
    : Number(accountDetails?.maturityAmount);
  // const grossInterest = maturityInterest;
  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.performanceHistory}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomColor: "#E2E2E2",
            overflow: "hidden",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.principalAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${
                  accountDetails?.currency?.code
                } ${accountDetails?.depositAmount?.toLocaleString()}`}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.grossInterest}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${accountDetails?.currency?.code} ${Number(Number(maturityInterest).toFixed(2)).toLocaleString()} `}
              </Text>
            </Col>
          </Row>
        </div>
        {/* <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${accountDetails?.currency?.code} ${maturityAmount?.toLocaleString()} `}
              </Text>
            </Col>
          </Row>
        </div> */}

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.netInterest}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${accountDetails?.currency?.code} ${Number(Number(netInterest).toFixed(2)).toLocaleString()} `}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${accountDetails?.currency?.code} ${Number(Number(maturityAmount).toFixed(2)).toLocaleString()} `}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.totalDeposits}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.summary?.totalDeposits
                  ? `${
                      accountDetails?.currency?.code
                    } ${accountDetails?.summary?.totalDeposits?.toLocaleString()}`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestEarned}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.summary?.totalInterestEarned
                  ? `${
                      accountDetails?.currency?.code
                    } ${accountDetails?.summary?.totalInterestEarned.toLocaleString()}`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function InterestDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.interestDetails}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nominalInterestrate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {`${accountDetails?.nominalAnnualInterestRate}%`}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCompoundingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCompoundingPeriodType?.value}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPostingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestPostingPeriodType?.value}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCalculatedUsing}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationType?.value}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{"Collect interest upfront"}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.isUpfrontFeesCollection ? "Yes" : "No"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{"Enable Manual Interest"}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.accountChart?.enableManualInterestEntry
                  ? "True"
                  : "False"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
